import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import MetricCard from "examples/Cards/MetricCard";

/**
 * MetricCardsContainer Component
 * Renders a dynamic grid of MetricCards based on the provided profiles' metrics.
 *
 * @param {Array} metrics - Array of profile metric objects [{ profilePic, name, metricName, metricValue, previousMetricValue }]
 */
function MetricCardsContainer({ metrics }) {
    if (!metrics || metrics.length === 0) return null;

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexWrap="wrap"
            gap={2}
            px={2}
            mt={3}
        >
            {metrics.map((metric, index) => (
                <Box key={index} sx={{ flex: "1 1 calc(20% - 16px)", minWidth: "250px", maxWidth: "300px" }}>
                    <MetricCard
                        profilePic={metric.profilePic}
                        name={metric.name || "Unknown Profile"}
                        platform={metric.platform || "Unknown"}
                        metricLabel={metric.metricName}
                        metricValue={metric.metricValue || metric.currentMetricValue}
                        previousMetricValue={metric.previousMetricValue}
                        isQualitative={metric.isQualitative}
                    />
                </Box>
            ))}
        </Box>
    );
}

// 🛡️ PropTypes Validation
MetricCardsContainer.propTypes = {
    metrics: PropTypes.arrayOf(
        PropTypes.shape({
            profilePic: PropTypes.string,
            name: PropTypes.string,
            metricName: PropTypes.string,
            metricValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            currentMetricValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            previousMetricValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        })
    ).isRequired,
};

export default MetricCardsContainer;
